import { render, staticRenderFns } from "./Proto.vue?vue&type=template&id=cff792f2&scoped=true&"
import script from "./Proto.vue?vue&type=script&lang=js&"
export * from "./Proto.vue?vue&type=script&lang=js&"
import style0 from "./Proto.vue?vue&type=style&index=0&id=cff792f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff792f2",
  null
  
)

export default component.exports